import { FeatureToggle } from '@ravago/shared/page-data/models/config';

export function isFeatureEnabled(featureToggles: FeatureToggle[], toggleName: string, defaultValue = false) {
  return featureToggles.find((featureToggle) => featureToggle.name === toggleName)?.allowed ?? defaultValue;
}
